export default function SuitableCompanies() {
  const sectors = [
    { icon: 'ri-building-2-line', name: 'B2B' },
    { icon: 'ri-shopping-bag-3-line', name: 'B2C' },
    { icon: 'ri-tools-line', name: 'Производство' },
    { icon: 'ri-code-s-slash-line', name: 'IT' },
    { icon: 'ri-ship-line', name: 'Логистика' },
    { icon: 'ri-heart-pulse-line', name: 'Медицина' },
    { icon: 'ri-building-4-line', name: 'Строительство' },
    { icon: 'ri-service-line', name: 'Услуги' },
    { icon: 'ri-bank-line', name: 'Финансы' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для каких компаний подходит
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Методика выявления потребностей универсальна и адаптируется под специфику любой отрасли и сегмента.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 max-w-4xl mx-auto">
          {sectors.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-4 md:p-5 text-center hover:bg-teal-50 transition-colors group cursor-default">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mx-auto mb-3 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-xl text-teal-600`}></i>
              </div>
              <span className="text-sm font-medium text-gray-700 group-hover:text-teal-700 transition-colors">{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}